import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter, Routes, Route, useLocation} from "react-router-dom";
import { HelmetProvider } from './lib/HelmetShim';
import AdminRoutes from "./AdminRoutes";
import Home from "./pages/Home";
import Product from "./pages/Product";
import Register from "./pages/Register";
import LoginPin from "./pages/LoginPin";
import Search from "./pages/Search";
import MyAccount from "./pages/MyAccount";
import MyPrices from "./pages/MyPrices";
import Messages from "./pages/Messages";
import Recipes from "./pages/Recipes";
import AppBarComponent from "./components/AppBarComponent";
import AdminBarComponent from "./components/AdminBarComponent";
import { AuthProvider } from './context/AuthContext';
import './theme/ochaka-vars.css';
import OAuthCallbackBridge from './pages/OAuthCallbackBridge';
import Logout from './pages/Logout';


const root = createRoot(document.getElementById("root"));

function AppBarSwitcher() {
    const location = useLocation();
    // Check if the path starts with '/admin'
    const isAdmin = location.pathname.startsWith('/admin');
    return null;
}


root.render(
    <HelmetProvider>
        <BrowserRouter>
            <AuthProvider>
                <AppBarSwitcher />
                <AdminRoutes />
                <Routes>

                    <Route path="/product/:productName" element={<Product />} />
                    <Route path="/search" element={<Search />} />
                    <Route path="/register" element={<Register />}/>
                    <Route path="/login" element={<LoginPin />}/>
                    <Route path="/logout" element={<Logout />}/>
                    <Route path="/account" element={<MyAccount />}/>
                    <Route path="/me" element={<MyAccount />}/>
                    <Route path="/my-prices" element={<MyPrices />}/>
                    <Route path="/messages" element={<Messages />}/>
                    <Route path="/recipes" element={<Recipes />}/>
                    <Route path="/receptai" element={<Recipes />}/>
                    <Route path="/" element={<Home/>}/>
                    <Route path=":category/*" element={<Home/>}/>
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    </HelmetProvider>
);
